/** Messages destinés à l'utilisateur, rédigés en français (ENF-012). */

import type { JSX } from 'preact';
import { dismissMessage, messages } from '../state';
import { Glyph } from '../icons';

export function MessageList(): JSX.Element | null {
  const current = messages.value;
  if (current.length === 0) return null;

  return (
    <div role="status" aria-live="polite">
      {current.map((message) => (
        <div
          key={message.id}
          class={message.kind === 'error' ? 'notice notice--error' : message.kind === 'info' ? 'notice notice--info' : 'notice'}
        >
          <div style="display:flex; gap:12px; align-items:flex-start;">
            <span style="flex:1;">{message.text}</span>
            <button
              type="button"
              class="icon-button"
              onClick={() => {
                dismissMessage(message.id);
              }}
            >
              <Glyph name="fermer" label="Fermer ce message" size={20} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
